import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { PickerQuickAccessProvider } from 'vscode/vscode/vs/platform/quickinput/browser/pickerQuickAccess';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { VIEWLET_ID } from 'vscode/vscode/vs/workbench/contrib/extensions/common/extensions';
import { IExtensionGalleryService, IExtensionManagementService } from 'vscode/vscode/vs/platform/extensionManagement/common/extensionManagement.service';
import { INotificationService } from 'vscode/vscode/vs/platform/notification/common/notification.service';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { IPaneCompositePartService } from 'vscode/vscode/vs/workbench/services/panecomposite/browser/panecomposite.service';

var InstallExtensionQuickAccessProvider_1, ManageExtensionsQuickAccessProvider_1;
const _moduleId = "vs/workbench/contrib/extensions/browser/extensionsQuickAccess";
let InstallExtensionQuickAccessProvider = class InstallExtensionQuickAccessProvider extends PickerQuickAccessProvider {
    static { InstallExtensionQuickAccessProvider_1 = this; }
    static { this.PREFIX = 'ext install '; }
    constructor(paneCompositeService, galleryService, extensionsService, notificationService, logService) {
        super(InstallExtensionQuickAccessProvider_1.PREFIX);
        this.paneCompositeService = paneCompositeService;
        this.galleryService = galleryService;
        this.extensionsService = extensionsService;
        this.notificationService = notificationService;
        this.logService = logService;
    }
    _getPicks(filter, disposables, token) {
        if (!filter) {
            return [{
                    label: ( localizeWithPath(_moduleId, 0, "Type an extension name to install or search."))
                }];
        }
        const genericSearchPickItem = {
            label: ( localizeWithPath(_moduleId, 1, "Press Enter to search for extension '{0}'.", filter)),
            accept: () => this.searchExtension(filter)
        };
        if (/\./.test(filter)) {
            return this.getPicksForExtensionId(filter, genericSearchPickItem, token);
        }
        return [genericSearchPickItem];
    }
    async getPicksForExtensionId(filter, fallback, token) {
        try {
            const [galleryExtension] = await this.galleryService.getExtensions([{ id: filter }], token);
            if (token.isCancellationRequested) {
                return [];
            }
            if (!galleryExtension) {
                return [fallback];
            }
            return [{
                    label: ( localizeWithPath(_moduleId, 2, "Press Enter to install extension '{0}'.", filter)),
                    accept: () => this.installExtension(galleryExtension, filter)
                }];
        }
        catch (error) {
            if (token.isCancellationRequested) {
                return [];
            }
            this.logService.error(error);
            return [fallback];
        }
    }
    async installExtension(extension, name) {
        try {
            await openExtensionsViewlet(this.paneCompositeService, `@id:${name}`);
            await this.extensionsService.installFromGallery(extension);
        }
        catch (error) {
            this.notificationService.error(error);
        }
    }
    async searchExtension(name) {
        openExtensionsViewlet(this.paneCompositeService, name);
    }
};
InstallExtensionQuickAccessProvider = InstallExtensionQuickAccessProvider_1 = ( (__decorate([
    ( (__param(0, IPaneCompositePartService))),
    ( (__param(1, IExtensionGalleryService))),
    ( (__param(2, IExtensionManagementService))),
    ( (__param(3, INotificationService))),
    ( (__param(4, ILogService)))
], InstallExtensionQuickAccessProvider)));
let ManageExtensionsQuickAccessProvider = class ManageExtensionsQuickAccessProvider extends PickerQuickAccessProvider {
    static { ManageExtensionsQuickAccessProvider_1 = this; }
    static { this.PREFIX = 'ext '; }
    constructor(paneCompositeService) {
        super(ManageExtensionsQuickAccessProvider_1.PREFIX);
        this.paneCompositeService = paneCompositeService;
    }
    _getPicks() {
        return [{
                label: ( localizeWithPath(_moduleId, 3, "Press Enter to manage your extensions.")),
                accept: () => openExtensionsViewlet(this.paneCompositeService)
            }];
    }
};
ManageExtensionsQuickAccessProvider = ManageExtensionsQuickAccessProvider_1 = ( (__decorate([
    ( (__param(0, IPaneCompositePartService)))
], ManageExtensionsQuickAccessProvider)));
async function openExtensionsViewlet(paneCompositeService, search = '') {
    const viewlet = await paneCompositeService.openPaneComposite(VIEWLET_ID, 0 , true);
    const view = viewlet?.getViewPaneContainer();
    view?.search(search);
    view?.focus();
}

export { InstallExtensionQuickAccessProvider, ManageExtensionsQuickAccessProvider };
